import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Injectable, Component, OnInit } from '@angular/core';
import { APPCONFIG } from '../config';
import { Observable } from 'rxjs/Observable';
// import { LayoutService } from '../layout/layout.service';
import { saveAs } from 'file-saver/FileSaver';
import { ToastsManager } from 'ng2-toastr';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs';

import { Angular2Csv } from 'angular2-csv';

import { CsvService } from "angular2-json2csv"

@Injectable()
export class Api implements OnInit {
    url: string = null;
    catalystUrl: string = null;
    rtUrl: string = null;
    eifUrl: string = null;
    server_region: string;
    // adpUrl:string = APPCONFIG.ADP_API_BASE_URL;

    private currentURL = new BehaviorSubject(null);
    // getCurentUrl = this.currentURL.asObservable();
    // starting badge functionality
    private isFirstLogin = new BehaviorSubject(null);
    getIfFirstLogin = this.isFirstLogin.asObservable();

    public PHONE_MASKNA = ['+', /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public PHONE_MASKPK = ['+', /\d/, /\d/, ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // public PHONE_MASK1 = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,/\d/, /\d/];
    public PHONE_MASK1;

    public PHONE_MASK = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public countryCodeMask = ['+', /\d/, /\d/, /\d/];
    public shippingCostPriceMask = [/\d/, /\d/, /\d/];
    // todo Phone number length after mask is 14;
    constructor(public http: Http,
        private snackBar: MatSnackBar,
        private router: Router,
        private toastr: ToastsManager,
        private csvService: CsvService
        //private vcr:ViewContainerRef
        // ,private layoutService:LayoutService

    ) {
        // this.toastr.setRootViewContainerRef(vcr);
    }

    ngOnInit() {
        //this.getURL();
    }

    isloggedInUserAdmin() {
        this.getADPCustomer();
        return this.getADPCustomer().roleId === 1;
    }

    isloggedInUserSaleRep() {
        this.getADPCustomer();
        return this.getADPCustomer().roleId === 3;
    }


    // setURL(){
    //     // todo  May 28 2019  by NH AR and NR Once
    //     //  On login the response object will bring the end points [rtapi,dtapi,billingapi] that needs to set for url  of user
    //     // inside set url method rettrieve the end points and set in this.url
    //     console.log("setURL.countryCode 123 --- ", localStorage.getItem("countryCode"));
    //
    //     if(localStorage.getItem('countryCode') == undefined){
    //         console.log('countryCode is undefined', localStorage.getItem('countryCode'));
    //         this.url = APPCONFIG.LOCAL_DTAPI_PK;
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //     }
    //     else if(localStorage.getItem("countryCode") === "+92") {
    //         this.url = APPCONFIG [APPCONFIG.ENVIRONMENT + "_DTAPI_PK"];
    //             this.server_region = 'PK';
    //         this.PHONE_MASK1=this.PHONE_MASKPK;
    //
    //     }
    //     else if(localStorage.getItem("countryCode") === "+1") {
    //         this.url = APPCONFIG [APPCONFIG.ENVIRONMENT + "_DTAPI_NA"];
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //
    //     }
    //     else
    //     {
    //         this.url = APPCONFIG.LOCAL_DTAPI_PK;
    //         console.log("ELSE OPTION RUNNING---------------------->", this.url)
    //         this.server_region = 'NA';
    //         this.PHONE_MASK1=this.PHONE_MASKNA;
    //
    //
    //     }
    //
    //
    //     console.log("setURl.this.url ---- ", this.url, "----");
    // }
    setUrls() {
        if (APPCONFIG.ENVIRONMENT == "COMMERCIAL" || APPCONFIG.ENVIRONMENT == "DEV") {

            this.url = localStorage.getItem('dtApiURL') + "api/v1";
            console.log("IF OPTION RUNNING---------------------->", this.url)
        }
        else {
            this.url = "http://localhost:8089/api/v1"
            console.log("ELSE OPTION RUNNING---------------------->", this.url)
        }

    }
    setUrlsRt() {
        if (APPCONFIG.ENVIRONMENT == "COMMERCIAL" || APPCONFIG.ENVIRONMENT == "DEV") {

            this.rtUrl = localStorage.getItem('rtApiURL') + "api/v2";
            this.eifUrl = localStorage.getItem('eifServerUrl') + "api/v1";
            console.log("IF OPTION RUNNING---------------------->", this.url)
        }
        else {
            // this.rtUrl = "http://localhost:8085/api/v2"
            this.rtUrl = localStorage.getItem('rtApiURL') + "api/v2";
            console.log("ELSE OPTION RUNNING---------------------->", this.url)
        }

    }

    setUrlsCatalyst() {
        if (APPCONFIG.ENVIRONMENT == "COMMERCIAL" || APPCONFIG.ENVIRONMENT == "DEV") {

            // this.url = localStorage.getItem('rtApiURL') + "api/v2";
            this.catalystUrl = localStorage.getItem('catalystApiURL') + "api/v1/";
            console.log("IF OPTION RUNNING---------------------->", this.url)
        }
        else {
            // this.catalystUrl = "http://localhost:8085/api/v2"
            this.catalystUrl = localStorage.getItem('catalystApiURL') + "api/v1/";
            console.log("ELSE OPTION RUNNING---------------------->", this.url)
        }


        // return APPCONFIG[APPCONFIG.ENVIRONMENT+"_CATALYST_SERVICE"] + '/';

    }

    setIfFirstLogin(firstLoginState: boolean) {
        this.isFirstLogin.next(firstLoginState)
    }
    // setCurrentURL(currentURL){
    // this.currentURL.next(currentURL)
    //     // console.log("curent urls", this.get)
    // }
    get(endpoint: string, params?: any, reqOpts?: any): any {
        this.setUrls(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new RequestOptions();
        }
        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new RequestOptions({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (let k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }


        return this.http.get(this.url + '/' + endpoint, reqOpts);

        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);

    }

    getCatalyst(endpoint: string, params?: any, reqOpts?: any): any {
        this.setUrlsCatalyst(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new RequestOptions();
        }
        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", localStorage.getItem("buyerUuid"));
            reqOpts = new RequestOptions({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (let k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }


        return this.http.get(this.catalystUrl + endpoint, reqOpts);

        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);

    }



    // POST

    post(endpoint: string, body: any, reqOpts?: any) {
        this.setUrls() /*SET URL According to the user Country */

        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new RequestOptions({ headers: headers });
        }


        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);

        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    }

    postCatalyst(endpoint: string, body: any, reqOpts?: any) {
        this.setUrlsCatalyst() /*SET URL According to the user Country */

        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", localStorage.getItem("buyerUuid"));
            reqOpts = new RequestOptions({ headers: headers });
        }


        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);

        return this.http.post(this.catalystUrl + endpoint, body, reqOpts);
    }

    getRt(endpoint: string, params?: any, reqOpts?: any): any {
        this.setUrlsRt(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new RequestOptions();
        }
        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new RequestOptions({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (let k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }


        return this.http.get(this.rtUrl + '/' + endpoint, reqOpts);

        //
        // if(this.getCountryCode() === "+92")
        //   return this.http.get(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        // else
        //   return this.http.get(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);

    }


    getEif(endpoint: string, params?: any, reqOpts?: any): any {
        this.setUrlsRt(); /*SET URL According to the user Country */
        if (!reqOpts) {
            reqOpts = new RequestOptions();
        }
        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new RequestOptions({ headers: headers });
        }
        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (let k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }

        console.log("UD UD UD")

        //Move it in RA Service
        return this.http.get(this.eifUrl + '/' + endpoint, reqOpts);
        // return this.http.get(this.rtUrl + '/' +endpoint, reqOpts);

    }



    // POST

    postRt(endpoint: string, body: any, reqOpts?: any) {
        this.setUrlsRt() /*SET URL According to the user Country */

        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new RequestOptions({ headers: headers });
        }


        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);

        return this.http.post(this.rtUrl + '/' + endpoint, body, reqOpts);
    }

    postImage(endpoint: string, body: any, reqOpts?: any) {

        let url = localStorage.getItem('imageUploderURL');
        url = url.split('upload.php')[0];


        return this.http.post(url + endpoint + this.getTokenFromLocalStorage(), body, reqOpts);
    }

    imageUploaderPost(endpoint: string, body: any, productId) {
        // let url =  APPCONFIG.java_image_uploader_url;
        let url = localStorage.getItem('imageUploderURL') + "/api/v1";
        console.log("Image uploadwr fuction called url : " + url + endpoint + body + productId);
        let headers = new Headers();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("productCode", productId);
        headers.append("size", APPCONFIG.imageCutterSizes);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        let reqOpts = new RequestOptions({ headers: headers });

        return this.http.post(url + endpoint, body, reqOpts);
    }

    brandImageUploaderPost(endpoint: string, body: any, brandImageName, size) {
        // let url =  APPCONFIG.java_image_uploader_url;
        let url = localStorage.getItem('imageUploderURL') + "/api/v1";
        console.log("Image uploadwr fuction called url : " + url + endpoint + body + brandImageName);
        let headers = new Headers();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("brandImageName", brandImageName);
        headers.append("size", size);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        let reqOpts = new RequestOptions({ headers: headers });

        return this.http.post(url + endpoint, body, reqOpts);
    }


    tempImageUploaderPost(endpoint: string, body: any) {
        // let url =  APPCONFIG.java_image_uploader_url;
        let url = localStorage.getItem('imageUploderURL') + "/api/v1";
        console.log("Image uploadwr fuction called url : " + url + endpoint + body);
        let headers = new Headers();
        // headers.append('Content-Type', 'multipart/form-data');
        // headers.append('Accept', 'application/json');
        headers.append("token", this.getTokenFromLocalStorage());
        // headers.append("productCode",productId);
        // headers.append("size",APPCONFIG.imageCutterSizes);
        headers.append("countryAbbrivation", localStorage.getItem('countryAbbrivation'));
        let reqOpts = new RequestOptions({ headers: headers });

        return this.http.post(url + endpoint, body, reqOpts);
    }



    postResetPassword(endpoint: string, body: any, reqOpts?: any) {
        // this.setUrls() /*SET URL According to the user Country */

        let url = APPCONFIG.ApiURL_dt;
        if (this.shouldToAddToken(endpoint)) {
            let headers = new Headers();
            headers.append("token", this.getTokenFromLocalStorage());
            reqOpts = new RequestOptions({ headers: headers });
        }


        //
        // if(this.getCountryCode() === "+92")
        //     return this.http.post(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.post(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);

        return this.http.post(url + '/' + endpoint, body, reqOpts);
    }


    loginRA(endpoint: string, body: any, reqOpts?: any) {
        return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    }

    getRa(endpoint: string, reqOpts?: any) {
        return this.http.get(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, reqOpts);
    }


    userAvailabilityRA(endpoint: string, body: any, reqOpts?: any) {

        return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, reqOpts, { params: body });
    }
    getCountryCodeRA(endpoint: string, body: any, reqOpts?: any) {

        return this.http.get(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, { params: body });
    }
    getCountryListRA(endpoint: string, body?: any, reqOpts?: any) {

        return this.http.get(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint);
    }
    registerUserRA(endpoint: string, body: any, reqOpts?: any) {
        return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    }

    activateRA(endpoint: string, body: any, reqOpts?: any) {

        return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/' + endpoint, body, reqOpts);
    }
    postRA(endpoint: string, body: any, reqOpts?: any) {

        return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint, body, reqOpts);
    }
    postRAWithTokenAndUuid(endpoint: string, body: any) {

        let headers = new Headers();
        headers.append("token", this.getTokenFromLocalStorage());
        headers.append("uuid", localStorage.getItem("uuid"));
        let reqOpts = new RequestOptions({ headers: headers });

        return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint, body, reqOpts);
    }
    getRA(endpoint: string, body?: any, reqOpts?: any) {

        return this.http.get(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RA_SERVICE"] + '/api/v1/' + endpoint);
    }

    put(endpoint: string, body: any, reqOpts?: any) {
        this.setUrls() /*SET URL According to the user Country */
        let headers = new Headers();
        headers.append("token", this.getTokenFromLocalStorage());
        reqOpts = new RequestOptions({ headers: headers });



        // if(this.getCountryCode() === "+92")
        //     return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);

        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    }

    putWithGivenToken(endpoint: string, body: any, token?, reqOpts?: any) {
        this.setUrls() /*SET URL According to the user Country */
        let headers = new Headers();
        headers.append("token", token);
        reqOpts = new RequestOptions({ headers: headers });



        // if(this.getCountryCode() === "+92")
        //     return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
        // else
        //     return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);

        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    }

    delete(endpoint: string, reqOpts?: any) {
        this.setUrls() /*SET URL According to the user Country */
        let headers = new Headers();
        headers.append("token", this.getTokenFromLocalStorage());
        reqOpts = new RequestOptions({ headers: headers });

        /*if(this.getCountryCode() === "+92")
            return this.http.delete(APPCONFIG.DT_API_PK + '/' + endpoint, reqOpts);
        else
            return this.http.delete(APPCONFIG.DT_API_NA + '/' +endpoint, reqOpts);*/

        return this.http.delete(this.url + '/' + endpoint, reqOpts);
    }

    patch(endpoint: string, body: any, reqOpts?: any) {
        this.setUrls() /*SET URL According to the user Country */

        /* if(this.getCountryCode() === "+92")
             return this.http.put(APPCONFIG.DT_API_PK + '/' + endpoint, body, reqOpts);
         else
             return this.http.put(APPCONFIG.DT_API_NA + '/' +endpoint, body, reqOpts);*/

        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    }


    postADP(endpoint: string, body: any, reqOpts?: any) {

        if (this.getCountryCode() === "+92")
            return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RTAPI_PK"] + '/' + endpoint, body, reqOpts);
        else
            return this.http.post(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RTAPI_NA"] + '/' + endpoint, body, reqOpts);
    }


    getADP(endpoint: string, params?: any, reqOpts?: any): any {
        if (!reqOpts) {
            reqOpts = new RequestOptions();

        }

        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new URLSearchParams();
            for (let k in params) {
                reqOpts.params.set(k, params[k]);
            }
        }

        if (this.getCountryCode() === "+92")
            return this.http.get(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RTAPI_PK"] + '/' + endpoint, reqOpts);

        else
            return this.http.get(APPCONFIG[APPCONFIG.ENVIRONMENT + "_RTAPI_NA"] + '/' + endpoint, reqOpts);

        // return this.http.get(this.adpUrl + '/' + endpoint, reqOpts);


    }



    getTokenFromLocalStorage() {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        //console.log("user",user.authToken);
        if (user) {
            return user.authToken;
        } else {
            return "";
        }
    }


    // tokenExpiredLogout(){
    //     this.snackBar.open("You Are Logged Out", "", {
    //         duration: 5000
    //     });
    //     this.router.navigate(['/extra/login']);
    // }

    gotoLogOut() {
        console.log('logout')
        // this.api.activateLoader();
        this.get("user/logout").subscribe((res) => {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('countryCode');
            localStorage.removeItem('billingCurrency');
            localStorage.removeItem('dtApiURL');
            localStorage.removeItem('billingApiUrl');
            localStorage.removeItem('imageUploderURL');
            localStorage.removeItem('imageStatsURL');
            localStorage.removeItem('countryAbbrivation');
            localStorage.removeItem("customerType");
            localStorage.removeItem("buyerUuid");
            localStorage.removeItem("supplierUuid");
            localStorage.removeItem("adpCustomer");
            localStorage.removeItem(APPCONFIG.prefix + 'isLoggedIn');
            this.router.navigate(['/extra/login'], { queryParams: { logoutStatus: 'success' } });

            // this.api.hideLoader();
        }, err => {
            console.log(err);
            //if (err.status == 401) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('countryCode');
            localStorage.removeItem('billingCurrency');
            localStorage.removeItem('dtApiURL');
            localStorage.removeItem('billingApiUrl');
            localStorage.removeItem('imageUploderURL');
            localStorage.removeItem('imageStatsURL');
            localStorage.removeItem('countryAbbrivation');
            localStorage.removeItem(APPCONFIG.prefix + 'isLoggedIn');
            this.router.navigate(['/extra/login'], { queryParams: { logoutStatus: 'success' } });
            // this.api.hideLoader();
            // }
        });
    }

    tokenExpiredLogout() {
        this.snackBar.open("You Are Logged Out", "", {
            duration: 5000
        });
        this.gotoLogOut();
    }

    toastMsg(msg, config: { duration?: number, type?: string } = {}) {
        // msg=msg.toLowerCase();
        // msg=msg.charAt(0).toUpperCase()+msg.slice(1);
        this.snackBar.open(msg, '', {
            duration: config.duration || 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
        });
    }


    showToastSuccess(msg) {
        this.toastr.success(msg, 'Success!');
    }

    showToastError(msg) {
        this.toastr.error(msg, 'Oops!');
    }

    showToastWarning(msg) {
        this.toastr.warning(msg, 'Alert!');
    }

    showToastInfo(msg) {
        this.toastr.info(msg);
    }

    showCustom() {
        this.toastr.custom('<span style="color: red">Message in red.</span>', null, { enableHTML: true });
    }


    getADPCustomerUUID() {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.adpCustomerInfo) {
            return user.adpCustomerInfo.uuid;
        } else {
            return "";
        }
    }
    getADPCustomer() {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            return user;
        } else {
            return "";
        }
    }
    getADPCustomerBillingCurrency() {
        var billingCurrency = localStorage.getItem('billingCurrency');
        if (billingCurrency) {
            return billingCurrency
        } else {
            return "";
        }
    }

    getADPCustomerTrialDays() {
        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (user && user.adpCustomerInfo) {
            return user.adpCustomerInfo.trialDays;
        } else {
            return 0;
        }
    }

    getADPCustomerType() {
        var customerType = localStorage.getItem("customerType");
        if (customerType) {
            return customerType;
        }
        else {
            return "";
        }
    }


    // activateLoader() {
    //   this.layoutService.updatePreloaderState('active');
    // }
    // hideLoader() {
    //   this.layoutService.updatePreloaderState('hide');
    // }


    downloadSaveFile(filename, text) {

        var dat = JSON.parse(text);
        //  var pom = document.createElement('a');
        // pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        // pom.setAttribute('download', filename);

        // if (document.createEvent) {
        //     var event = document.createEvent('MouseEvents');
        //     event.initEvent('click', true, true);
        //     pom.dispatchEvent(event);
        // }
        // else {
        //     pom.click();
        // }
        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: true
        };

        // var finaldat = dat.data.unshift(dat.fields);


        // const data = ;
        // const headers = text.fields
        new Angular2Csv(dat.data, filename.split(".")[0], { headers: (dat.fields) });
        // this.csvService.download(dat.data,'My Report');
        //downloadCsv(data, headers);




        //var blob = new Blob([text], {type: "text/csv;charset=utf-8"});

        // var blob = new Blob([text], {type: "text/plain"});
        // var href = window.URL.createObjectURL(blob);

        // var link = document.createElement("a");
        // link.setAttribute("href", href);
        // link.setAttribute("download", filename);
        // document.body.appendChild(link); // Required for FF

        // link.click(); // This will download the data file named "my_data.csv".

        // document.body.removeChild(link);

        // var textEncoder = new TextEncoder('windows-1252', {NONSTANDARD_allowLegacyEncoding: true});

        // //var BOM = "\uFEFF";
        // var csvData = text;
        // var csvDataEncoded = textEncoder.encode([csvData]);
        // var file = new Blob([csvDataEncoded],{type: "text/plain;charset=windows-1252;"});
        // saveAs(file, filename);

    }


    getUser() {
        return JSON.parse(localStorage.getItem("currentUser"));
    }

    getCountryCode() {
        console.log("     -------------------------     ", localStorage.getItem("countryCode"));
        return localStorage.getItem("countryCode");
    }

    downloadSaveFileCSV(filename, text) {


        var pom = document.createElement('a');
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        pom.setAttribute('download', filename);

        if (document.createEvent) {
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            pom.dispatchEvent(event);
        }
        else {
            pom.click();
        }
        document.body.removeChild(pom);

    }

    // Should add token for URL decision making
    shouldToAddToken(endpoint) {

        var urlsNotToAddToken = [
            "recoverPassword"
        ];

        for (let endP of urlsNotToAddToken) {
            // String.prototype.indexOf returns the position of the
            // string in the other string. If not found, it will return -1
            if (endpoint.indexOf("recoverPassword") !== -1) {
                return false;
            }
        }
        return true;

        // if(endpoint.indexOf("recoverPassword") !== -1){
        //   return false;
        // }else{
        //   return true;
        // }
    }





}


export let ApplicationVariables: any = { currentShipmentNoticePage: 0, currentShipmentNoticeSearchQuery: "", currentShipmentNoticeOffset: 0 };



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/providers/api.ts